import React from 'react'
import UiMainWrapper from "../../components/common/UiMainWrapper"
import TopHeader from "../../components/header/TopHeader"
import LoyaltyStoreBanner from "./Views/LoyaltyStoreBanner"
import UiRangeSlider from "../../components/form/UiRangeSlider"
import { UiBannerBottomBar } from '../../components/common/UiBannerBottomBar';
import {
    UiContentWr,
    UiTopInputWr,
    UiTopInputHeading,
    UiContentCol,
    UiContentColWithSlider,
    UiColTitleWr,
    UiColTitle,
    UiViewAll,
    UiTabContentWr,
    UiTabContent
} from "../../components/common/UiPageElements"
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import {
    UiFilterWr,
    UiFilterTitle,
    UiFilterSeeMore
} from "../../components/common/UiFilterComponents"
import UiFiterInput from "../../components/form/UiFilterInput"
import { UiCheckboxInput } from "../../components/form/UiInput"
import LoyaltyStoreList from "./Views/LoyaltyStoreList"
import LoyaltyStoreFilter from "./Views/LoyaltyStoreFilter"
import Footer from "../../components/footer/Footer"

export default function LoyaltyStore(props) {

    return (
        <>
            <UiMainWrapper>
                <TopHeader />
                <LoyaltyStoreBanner title="Browse Loyalty Stores"
                    description="Your already working hard, enjoy the benefits of various rewards you, your team and your family can enjoy." />
                <UiBannerBottomBar
                    prevPage="Shop"
                    prevPageLink="/ui"
                    currentPage="Broswe All Products"
                    currentPageLink="/ui/incentives-pre-register" />
                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="4" xl="3">
                            <UiContentCol>
                                <LoyaltyStoreFilter />
                            </UiContentCol>
                        </UiCol>
                        <UiCol lg="8" xl="9">
                            <LoyaltyStoreList />
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
                <Footer />
            </UiMainWrapper>

        </>
    )
}
